import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getAccessibleWorkspacesWithCaching} from "~/utilities/queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w")({
    beforeLoad: async ({context}) => {
        const accessibleWorkspacesResult = await getAccessibleWorkspacesWithCaching({
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
            queryClient: context.queryClient,
        });
        if (accessibleWorkspacesResult.success === false) {
            throw accessibleWorkspacesResult.error;
        }

        return {
            accessibleWorkspaces: accessibleWorkspacesResult.data,
        };
    },
    loader: async () => {},
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
